import React, { Fragment, useState } from "react";
import { useFancyLogic } from "../../useLogic/useFancyLogic";
import BetSlipContext from "../../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import { isEmpty, isNumber, startCase } from "lodash";
import { formatWithCommas } from "../../../Utils/Toast";
import BetSlipSkyWeb from "./BetSlip";
import Message from "./Message";

const FancySkyWeb = ({
  fancy,
  detail,
  profileData,
  position,
  addToFavioute,
  favouriteList,
  fancyHeader,
  setFancyModal,
  setFancyTab,
}) => {
  const [fancyHeaderKey, setFancyHeaderKey] = useState("All");
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const toastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.toastObject;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const { data, localLimit, handelChange, mergeAndCalculate } = useFancyLogic({
    fancy,
    detail,
    profileData,
    favouriteList,
    fancyHeaderKey,
  });
  return (
    <div
      id="fancyBetTable_34924384"
      className="bets-wrap fancy_bet"
      style={{}}
      name="multiMarketItem"
    >
      <div id="fancyBetHead" className="fancy-head">
        <h4 className="in-play">
          {/* a id="multiMarketPin" class="add-pin" name="te" style="cursor: pointer" title="Add to Multi Markets"></a*/}
          <span id="headerName">Fancy Bet</span>
          <a
            className="btn-fancybet_rules"
            onclick="javascript: $j('[id^=fancyBetRulesWrap]').fadeIn()"
          />
        </h4>
        {(detail?.premiumFancy == "on" && detail?.hasSportBook) &&
        <a
          onClick={() => setFancyTab("Premium")}
          id="showSportsBookBtn"
          className="other-tab"
          onclick="javascript: SportsBookEventHandler.activeSportsBook();"
          style={{}}
        >
          <span className="tag-new">New</span>
          Premium Cricket
        </a>}
      </div>
      <div id="fancyBetTabWrap" className="fancy_bet_tab-wrap" style={{}}>
        <ul className="special_bets-tab">
          {fancyHeader?.map((res, index) => {
            return (
              <li
                onClick={() => {
                  setFancyHeaderKey(res?.type);
                }}
                className={res?.type == fancyHeaderKey ? "select" : ""}
              >
                <a fancybettabtype={1}> {res?.name}</a>
              </li>
            );
          })}
        </ul>
      </div>
      <p id="fancyBetNoBet" className="no_bet" style={{ display: "none" }}>
        has no markets
      </p>
      <table id="fancyBetMarketList" className="bets" style={{}}>
        <colgroup>
          <col span={1} width={280} />
          <col span={1} width={70} />
          <col span={1} width={70} />
          <col span={1} width={70} />
          <col span={1} width={70} />
          <col span={1} width={70} />
          <col span={1} width={70} />
        </colgroup>
        <tbody>
          <tr className="colgroup-adjust">
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
          <tr id="fancyBetSpecialBet" className="special_bet">
            <td colSpan={7}>
              <h3>
                <a
                  id="multiMarketPin"
                  className="add-pin"
                  title="Add to Multi Markets"
                >
                  Add Pin
                </a>
                Fancy Bet
              </h3>
            </td>
          </tr>
          <tr className="bet-all">
            <td />
            <td className="refer-bet" colSpan={2} />
            <td>No</td>
            <td>Yes</td>
            <td className="refer-book" colSpan={2} />
          </tr>
          {data?.map((item, index) => {
            if (
              item?.odds?.ms == 4 ||
              item?.odds?.rt?.length == 0 ||
              item?.odds?.ms == 2 ||
              isEmpty(item?.odds?.rt)
            ) {
              return null;
            } else {
              let findPosition = position?.find((res) => {
                return res?.selectionId == item?.selectionId;
              });
              let oldPosition = !isEmpty(findPosition)
                ? findPosition?.position
                : "";

              let newPosition = "";
              if (oldPosition && position) {
                let oldPositionData = findPosition || [];

                if (betSlipObject?.teamName === item?.name && showBetDialog) {
                  betSlipObject.betType = betSlipObject?.object?.ib
                    ? "Yes"
                    : "No";

                  newPosition =
                    oldPositionData && oldPositionData?.betRunPosition
                      ? mergeAndCalculate(betSlipObject, oldPositionData)
                      : 0;
                }
              } else {
                if (betSlipObject?.teamName === item?.name && showBetDialog) {
                  if (betSlipObject?.object?.ib) {
                    if (Math.abs(item?.position) > 0) {
                      let backLoss =
                        Number(betSlipObject?.bidPrice) +
                        Number(item?.position);
                      newPosition = backLoss;
                    } else {
                      let backLoss = Number(betSlipObject?.bidPrice);
                      newPosition = backLoss;
                    }
                  } else {
                    if (Math.abs(item?.position) > 0) {
                      let backProfit =
                        (betSlipObject?.bidPrice * betSlipObject?.object?.pt) /
                        100;
                      newPosition = Number(backProfit) + Number(item.position);
                    } else {
                      let backProfit =
                        (betSlipObject?.bidPrice * betSlipObject?.object?.pt) /
                        100;
                      newPosition = backProfit;
                    }
                  }
                }
              }

              let condition =
                betSlipObject?.tamName === item?.name &&
                Math.abs(newPosition) >= 0;

              return (
                <Fragment>
                  {(item?.odds?.ms == 9 ||
                    item?.odds?.ms == 2 ||
                    item?.odds?.ms == 3 ||
                    item?.odds?.ms == 4) && (
                    <tr id="suspend_2680253" class="fancy-suspend-tr">
                      <th></th>
                      <td colspan="2"></td>
                      <td class="fancy-suspend-td" colspan="2">
                        <div id="suspendClass" class="fancy-suspend">
                          <span id="info">Suspend</span>
                        </div>
                      </td>
                      <td colspan="2"></td>
                    </tr>
                  )}
                  <tr>
                    <th colSpan={3}>
                      <dl className="fancy-th-layout">
                        <dt>
                          <p id="marketName">{item?.name}</p>{" "}
                          {isNumber(oldPosition) &&
                            Math.abs(item?.position) > 0 && (
                              <span
                                id="before"
                                className={item?.position > 0 ? "win" : "lose"}
                              >
                                {isNumber(oldPosition)
                                  ? `(${Math?.abs(item?.position).toFixed(2)})`
                                  : ""}
                              </span>
                            )}
                          {betSlipObject?.teamName === item?.name &&
                            Math.abs(newPosition) >= 0 && (
                              <span
                                id="after"
                                className={`to-${
                                  newPosition > 0 ? "win" : "lose"
                                } `}
                              >
                                {`(${Math.abs(newPosition).toFixed(2)})`}
                              </span>
                            )}
                        </dt>
                        <dd className="dd-tips">
                          <ul className="fancy-tips">
                            <li
                              id="remarkFirstRow"
                              style={{ display: "none" }}
                            />
                            <li
                              id="remarkSecondRow"
                              style={{ display: "none" }}
                            />
                          </ul>{" "}
                          {!isEmpty(findPosition) && (
                            <a
                              id="fancyBetBookBtn"
                              className="btn-book"
                              onClick={() =>
                                setFancyModal({
                                  status: true,
                                  object: {
                                    ...item,
                                    match: detail?.eventName,
                                    prevPosition: isNumber(oldPosition),
                                  },
                                })
                              }
                            >
                              Book
                            </a>
                          )}
                        </dd>
                      </dl>
                    </th>
                    <td colSpan={2} className="multi_select ">
                      <ul>
                        <li
                          title={
                            item?.odds?.rt?.length > 0
                              ? item?.odds?.rt[0]?.rt
                              : ""
                          }
                          id={"lay_odds_fancy_" + index}
                          onClick={(e) => {
                            {
                              handelChange(
                                item?.odds?.rt[0],
                                "No",
                                item?.name,
                                item,
                                e
                              );
                            }
                          }}
                          className={`lay-1 ${
                            Number(
                              document.getElementById("lay_odds_fancy_" + index)
                                ?.title
                            ) !== item?.odds?.rt[0]?.rt
                              ? "spark"
                              : ""
                          }`}
                        >
                          <a id="runsInfo" style={{ cursor: "pointer" }}>
                            {item?.odds?.rt[0]?.rt || ""}
                            <span>{item?.odds?.rt[0]?.pt || ""}</span>
                          </a>
                        </li>
                        <li
                          className={`back-1 ${
                            betSlipObject?.teamName == item?.name &&
                            betSlipObject?.odds == item?.odds?.rt[1]?.rt &&
                            showBetDialog &&
                            betSlipObject?.betType == "Yes"
                              ? "yes-active"
                              : ""
                          } ${
                            Number(
                              document.getElementById(
                                "back_odds_fancy_" + index
                              )?.title
                            ) !== item?.odds?.rt[1]?.rt
                              ? "spark"
                              : ""
                          }`}
                          title={
                            item?.odds?.rt?.length > 0
                              ? item?.odds?.rt[1]?.rt
                              : ""
                          }
                          id={"back_odds_fancy_" + index}
                          onClick={(e) => {
                            {
                              handelChange(
                                item?.odds?.rt[1],
                                "Yes",
                                item?.name,
                                item,
                                e
                              );
                            }
                          }}
                        >
                          <a id="runsInfo" style={{ cursor: "pointer" }}>
                            {item?.odds?.rt[1]?.rt || ""}
                            <span>{item?.odds?.rt[1]?.pt || ""}</span>
                          </a>
                        </li>
                      </ul>
                    </td>
                    <td className="td-fancy_merge" colSpan={2}>
                      <dl className="fancy-info">
                        <dt>Min/Max</dt>
                        <dd id="minMax">
                          {formatWithCommas(localLimit?.minAmount)} /{" "}
                          {formatWithCommas(localLimit?.maxAmount)}
                        </dd>
                      </dl>
                      <dl className="fancy-info">
                        <dt id="rebateName" style={{ display: "none" }}>
                          Rebate
                        </dt>
                        <dd id="rebate" style={{ display: "none" }} />
                      </dl>
                    </td>
                  </tr>
                  {showBetDialog &&
                    betSlipObject?.teamName == item?.name &&
                    betSlipObject?.object?.centralizedId ==
                      item?.centralizedId &&
                    betSlipObject?.playType == "fancy" && <BetSlipSkyWeb />}
                  {!isEmpty(toastObject?.message) &&
                    toastObject?.status &&
                    toastObject?.gameType == "fancy" &&
                    toastObject?.id == item?.centralizedId && (
                      <Message
                        toastObject={toastObject}
                        setToastObject={setToastObject}
                      />
                    )}
                </Fragment>
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FancySkyWeb;
